import { CustomColumn } from '../../../types/customColumn';

export const productSettlementColumns: CustomColumn<any>[] = [
  {
    Header: '#',
    id: 'rowIndex',
    accessor: 'id',
    customCell: (cell: any) => {
      const index = cell.row.index;
      const { pageIndex = 0, pageSize = 10 } = cell.table?.state || {};
      return pageIndex * pageSize + index + 1;
    },
  },
  {
    Header: 'Sucursal',
    accessor: 'branchName',
    customCell: ({ value }) => (
      <div className="text-sm font-medium text-black dark:text-white">
        {value}
      </div>
    ),
  },
  {
    Header: 'Cantidad',
    accessor: 'quantity',
    customCell: ({ value }) => (
      <div className="text-sm">{Number(value).toFixed(2)}</div>
    ),
  },
  {
    Header: 'Costo Unitario',
    accessor: 'unitCost',
    customCell: ({ value }) => (
      <div className="text-sm">${Number(value).toFixed(4)}</div>
    ),
  },
  {
    Header: 'Fecha',
    accessor: 'createdAt',
    customCell: ({ value }) => {
      const formatted = new Date(value).toLocaleString('es-SV', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
      return (
        <div className="text-sm text-gray-600 dark:text-gray-400">
          {formatted}
        </div>
      );
    },
  },
];
